virtual function bit has_driver();
  return ({{ interfaceBoundVariable.identifier }} && ({{ activeStateVariable.identifier }} == UVM_ACTIVE));
endfunction
